<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div class="chat-widget-footer" data-testid="chat-widget-footer">
	<div class="disclaimer">
		{#if !currentConnectedToDynamicsAgent}
			Our AI Assistant can make mistakes.
			<img src="sparkle.svg" alt="sparkle" />
			Check important info.
		{:else}
			{fullBrandNameDisplay}
		{/if}
	</div>
</div>

<script lang="ts">
	import { chatSession, connectedToAgent } from '$lib/stores/chatSessionStore';
	import { fullBrandName } from '../../utilities/brandingConfigurations';

	const fullBrandNameDisplay = fullBrandName[$chatSession.brand];
	$: currentConnectedToDynamicsAgent = $connectedToAgent;
</script>

<style>
	.chat-widget-footer {
		font-weight: bold;
		justify-content: space-between;
		align-items: center;
		flex-shrink: 0;
		padding: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		cursor: move;
		font-size: 12px;
		line-height: 18px;
	}
	.disclaimer {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-size: 11px;
		color: #b3b3b3;
		text-align: center;
	}
</style>
